import { RawGallery } from '@entities/Gallery/Types';

export const MockRawGalleries: RawGallery[] = [
    {
        id: 170,
        galleryable_id: 114,
        galleryable_type: 'App\\Models\\Fragment',
        created_at: '2024-12-02T13:30:31.000000Z',
        updated_at: '2024-12-02T13:30:31.000000Z',
        deleted_at: null,
        medias: [
            {
                id: 199,
                gallery_id: 170,
                filename: 'd0SY35qnDl1CNQP89mHNjPEzSxcmmdjYd18TLBTH.png',
                mime_type: 'image/png',
                size: 929128,
                url: 'https://api.gobuildbom.io/images/d0SY35qnDl1CNQP89mHNjPEzSxcmmdjYd18TLBTH.png',
                created_at: '2024-12-02T13:30:31.000000Z',
                updated_at: '2024-12-02T13:30:31.000000Z',
                deleted_at: null,
            },
        ],
    },
    {
        id: 1100,
        galleryable_id: 86,
        galleryable_type: 'App\\Models\\Fragment',
        created_at: '2024-12-06T11:15:19.000000Z',
        updated_at: '2024-12-06T11:15:19.000000Z',
        deleted_at: null,
        medias: [
            {
                id: 1183,
                gallery_id: 1100,
                filename: 'J0cv7sIqUzZ8XXeGToZg6gibbhwEp4sN7GjVrPrJ.png',
                mime_type: 'image/png',
                size: 705654,
                url: 'https://api.gobuildbom.io/images/J0cv7sIqUzZ8XXeGToZg6gibbhwEp4sN7GjVrPrJ.png',
                created_at: '2024-12-06T11:15:19.000000Z',
                updated_at: '2024-12-06T11:15:19.000000Z',
                deleted_at: null,
            },
        ],
    },
];
